module.exports = __webpack_public_path__ + "static/1-3-33b4dfd4bc543cc72fe89540834df892.png";